import { useEffect, useRef } from 'react'
import type { DataLayerAction } from '@corratech/pylot-tag-manager/src//TagContext.d'
import { useRouter } from 'next/router'
import { resolvePageData } from '@corratech/pylot-tag-manager/src/TrackUrlChange/resolvePageData'
import { useStoreConfig } from 'config'
import { parseUrlPathName } from '@corratech/pylot-tag-manager/src/utils/parseUrlPathName'

export const TrackUrlChange = ({
    dataLayerAction
}: {
    dataLayerAction: DataLayerAction
}): null => {
    const router = useRouter()
    const { asPath, isFallback } = router
    const trackedPagePath = useRef<string>()
    const {
        base: {
            url: { model }
        },
        seo: { customPages }
    } = useStoreConfig()
    const handleRouteChange = (path: string) => {
        const newPath = parseUrlPathName(path)
        if (newPath === trackedPagePath.current) {
            return
        }
        dataLayerAction({
            type: 'PAGE_VIEW',
            data: {
                ...resolvePageData(newPath, customPages, model),
                virtualPagePath: newPath
            }
        })
        trackedPagePath.current = newPath
    }

    const bannerEvent = (bannerData: EventTarget, bannerClassName: string) => {
        dataLayerAction({
            type: 'BANNER_CLICK',
            data: {
                BannderData: bannerData,
                containerID: bannerClassName
            }
        })
    }

    useEffect(() => {
        if (!isFallback) {
            handleRouteChange(asPath)
        }

        const handleLinkClick = (event: Event) => {
            const target = event.target as Element
            const promotionalElement = target.closest('.banner-tracking')
            if (promotionalElement) {
                event.preventDefault()
                const res = promotionalElement.className.split(' ')
                const bannerClassName = res[res.length - 1]
                bannerEvent(event.target!, bannerClassName)
            }
        }

        const allLinks = document.querySelectorAll('body a')

        allLinks.forEach(function (link) {
            const linkAttribute = link as HTMLAnchorElement
            const linkss = linkAttribute?.href
            if (
                window !== undefined &&
                !linkss.includes(window?.location?.origin)
            ) {
                return false
            }
            link.addEventListener('click', handleLinkClick)
        })
    }, [asPath])

    // TODO: add checkout step tracking here, once checkout implementation is done

    return null
}
